import { filtersSchema } from '@/helpers/build-get-events-filter';
import { parseEnv } from '@/helpers/route-utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { SORTABLE_EVENT_COLUMNS } from 'utils';
import * as z from 'zod/v4';

export const Route = createFileRoute('/_auth/$env/events/all')({
  params: parseEnv(),
  validateSearch: zodValidator(
    z.object({
      search: z.string().optional(),
      page: z.coerce.number().optional().default(1),
      pageSize: z.coerce.number().optional().default(10),
      sortBy: z.enum(SORTABLE_EVENT_COLUMNS).optional(),
      sortOrder: z.enum(['asc', 'desc']).optional(),
      filters: filtersSchema.optional(),
      getGrandChildren: z.boolean().optional().default(true),
      permanent: z.boolean().default(false),
    }),
  ),
});
